module.exports = __webpack_public_path__ + "static/media/logoAia.86176288.svg";